import Component from '@bythepixel/component-loader';
import BaseForm from './base';

export default class SellMyRvForm extends Component {
  static selector = '[data-comp-form-sell-my-rv]'

  constructor(containerEl) {
    super(containerEl);

    // eslint-disable-next-line no-new
    new BaseForm(containerEl, `${this.$id}_secureInput`, '/api/leads/sell-my-rv');
  }
}
